import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, DataStateChangeEvent, FilterService, RowClassArgs } from '@progress/kendo-angular-grid';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DispatchLaborBus } from '@app/cp/shared/models/DispatchLaborBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { process, State, CompositeFilterDescriptor, filterBy, FilterDescriptor, aggregateBy } from '@progress/kendo-data-query';
import { PersonSel } from '@app/cp/shared/models/PersonSelBus';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { ReportConstructionPOInfo } from "@app/cp/shared/models/ReportConstructionPOInfo";
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { DispatchPage } from '../../shared/models/DispatchPage';
import { DispatchQvLaborAddDialogComponent } from '../dispatch-qv-labor-add-dialog/dispatch-qv-labor-add-dialog.component';
import { GItem } from '../../shared/models/GItem';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'dispatch-qv-labor',
    templateUrl: './dispatch-qv-labor.component.html',
    styleUrls: ['./dispatch-qv-labor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchQVLaborComponent extends BaseGridEditLineComponent<DispatchLaborBus, null, DispatchesService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    timeTypeFC: MSFilterClass = new MSFilterClass('timeTypeName');
    laborTypeFC: MSFilterClass = new MSFilterClass('laborTypeName');
    overlap = null;
    maxEndDate: Date;
    minEndDate: Date;

    @Input() dispatchPage: DispatchPage;
    @Input() sublings: GItem[] = [];
    curDispatchLaborBus: DispatchLaborBus;
    @ViewChild('dispatchQvLaborAddDialog') public dispatchQvLaborAddDialog: DispatchQvLaborAddDialogComponent;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "DispatchLaborBus";
        this.appCode = "DispatchLabor";
        this.aggregates = [{ field: 'hours', aggregate: 'sum' }, { field: 'paidHours', aggregate: 'sum' }, { field: 'workedHours', aggregate: 'sum' }, { field: 'travelHours', aggregate: 'sum' }];
        this.state.group = [{ field: 'hours', aggregates: this.aggregates }];

    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchLaborId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'hours': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'laborTypeId': new UntypedFormControl(),
            'timeTypeId': new UntypedFormControl(),
            'isHelper': new UntypedFormControl(),
            'nonPaid': new UntypedFormControl(),
            'startDate': new UntypedFormControl(),
            'endDate': new UntypedFormControl(),
            'useLocationRate': new UntypedFormControl(),
            'mgrApproved': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'fullName': new UntypedFormControl(),
            'timeTypeName': new UntypedFormControl(),
            'laborTypeName': new UntypedFormControl(),
        });

    }
    setForm() {
        this.editForm.patchValue({
            dispatchLaborId: this.selectedData.dispatchLaborId,
            dispatchId: this.selectedData.dispatchId,
            hours: this.selectedData.hours,
            personId: this.selectedData.personId,
            laborTypeId: this.selectedData.laborTypeId,
            timeTypeId: this.selectedData.timeTypeId,
            isHelper: this.selectedData.isHelper,
            nonPaid: this.selectedData.nonPaid,
            startDate: this.selectedData.startDate,
            endDate: this.selectedData.endDate,
            useLocationRate: this.selectedData.useLocationRate,
            mgrApproved: this.selectedData.mgrApproved,
            insertUserId: this.selectedData.insertUserId,
            insertDt: this.selectedData.insertDt,
            updateUserId: this.selectedData.updateUserId,
            updateDt: this.selectedData.updateDt,
            fullName: this.selectedData.fullName,
            timeTypeName: this.selectedData.timeTypeName,
            laborTypeName: this.selectedData.laborTypeName,
        });
        this.minEndDate = this.selectedData.startDate;
        this.maxEndDate = DateFunctions.addDays(this.selectedData.startDate, 1);
    }
    customCanSaveForm() {
        var startDate = this.editForm.value.startDate;
        var endDate = this.editForm.value.endDate;
        if (startDate < endDate) {
            var endTestDate = DateFunctions.addDays(startDate, 1);
            if (endDate <= endTestDate) {
                if (this.overlap) {
                    return false;
                }
                return true;
            }
        }

        return false;
    }
    getChangedObject(data: DispatchLaborBus) {
        let busObj: DispatchLaborBus = new DispatchLaborBus(data);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    protected save(data: DispatchLaborBus) {
        let busObj: DispatchLaborBus = this.getChangedObject(data);
        console.log("dl-save->:", busObj);
//        return;
        this.svc_data.saveDispatchLaborApprovalQV(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let dataObj: DispatchLaborBus = new DispatchLaborBus(info.primaryReturn);
                dataObj = this.setFromReferenceData(dataObj);
                this.removeLocalAdded();
                this.saveSuccess(dataObj);
                this.processGridData();
            }
            else {
                this.saveError(info.primaryReturn, info.message);
            }
        });
    }
    deleteIndividual(data: DispatchLaborBus) {
        if (data.hasId) {
            this.svc_data.deleteLabor(data.dispatchLaborId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }

    setFromReferenceData(data: DispatchLaborBus) {
        data.fullName = this.personName(data.personId);
        data.laborTypeName = this.referenceData.getLaborTypes(data.laborTypeId);
        data.timeTypeName = this.referenceData.getTimeTypes(data.timeTypeId);
        return data;
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            let payableRows = this.gridData.filter(s => s.nonPaid === false);
            this.aggregateResults = aggregateBy(payableRows, this.aggregates);

        }
    }
    customCheckBoxChanged(e: any, dataItem: DispatchLaborBus, rowIndex, column, columnIndex, setEditMode: boolean = true) {
        if (!setEditMode) {
            dataItem.isUpdated = true;
            this.setDirty();
            this.SetChanged();
        }
        else {
            if (column.field === "nonPaid") {
                this.editForm.patchValue({
                    nonPaid: e.target.checked
                });

            }

        }
    }
    public onChangeStartDate(value: Date): void {
        this.minEndDate = new Date(value);
        this.maxEndDate = DateFunctions.addDays(this.minEndDate, 1);
        if (!this.editForm.value["endDate"]) {
            this.editForm.patchValue({
                endDate: this.minEndDate
            });

        } else {
            this.validateDispatchLaborOverLap();
        }
        this.editForm.updateValueAndValidity();
    }
    afterSaveCurrent() { this.overlap = null; }
    private async validateDispatchLaborOverLap(): Promise<boolean> {

        if (this.compFeatureFlagSet.featureFlagSet['prevent-duplicate-time-entries-from-being-entered']) {
            if (this.editForm.value.personId && this.editForm.value.endDate && this.editForm.value.startDate) {
                var startDate = this.editForm.value.startDate;
                var endDate = this.editForm.value.endDate;
                var personId = this.editForm.value.personId;
                var dispatchLaborId = "";
                if (this.editForm && this.editForm.value && this.editForm.value.dispatchLaborId) {
                    dispatchLaborId = this.editForm.value.dispatchLaborId;
                }

                var overlap = this.gridData.filter(a => a.personId == personId
                    && a.dispatchLaborId != dispatchLaborId
                    && ((a.startDate > startDate && a.startDate < endDate)
                        || (a.endDate > startDate && a.endDate < endDate)
                        || (a.startDate <= startDate && endDate <= a.endDate))
                )
                 if (overlap.length) {
                    this.overlap = {
                        startDate: overlap[0].startDate,
                        endDate: overlap[0].endDate,
                        dispatchNumber: "Current"
                    }
                    return false;
                }
                this.overlap = null;
                var changed = this.gridData.filter(a => a.isUpdated).map(a => a.dispatchLaborId);
                if (this.editForm && this.editForm.value && this.editForm.value.dispatchLaborId) {
                    changed.push(this.editForm.value.dispatchLaborId);
                }
                var busObj =
                {
                    startDate: DateFunctions.getDateTimeWithUTCOffset(this.editForm.value.startDate),
                    endDate: DateFunctions.getDateTimeWithUTCOffset(this.editForm.value.endDate),
                    personId: this.editForm.value.personId,
                    dispatchLaborIdsToSkip: changed
                }

                await this.svc_data.validateDispatchLaborOverLap(busObj).toPromise().then((data: any) => {
                    if (data.laborOverlap) {
                        this.overlap = {
                            startDate: data.overlaps[0].startDate,
                            endDate: data.overlaps[0].endDate,
                            dispatchNumber: data.overlaps[0].dispatchNumber
                        }
                    }
                    else {
                        this.overlap = null;
                    }
                })

            }
            if (this.overlap) {
                return false;
            }
        } else { this.overlap = null; }
        return true;
    }

    addLabor() {
        this.dispatchQvLaborAddDialog.show(null);

    }
    cancelClick(event) { event.preventDefault();}
    confirmAddLabor(data: ConfirmOutput) {

        if (data.dialogResult === CPDialogResult.ok) {
            var newLabor = this.dispatchQvLaborAddDialog.getNewPart();
            newLabor.dispatchId = this.parentId;
            this.saveNewLabor(newLabor);

        }
    }
    showAdd() {
        return this.canAddEdit;
    }
    protected saveNewLabor(data: DispatchLaborBus) {
    //    data.dispatchId = this.dispatchPage.dispatchId;
        this.svc_data.saveLabor(data).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {

                let dataObj: DispatchLaborBus = new DispatchLaborBus(info.primaryReturn);
                dataObj = this.setFromReferenceData(dataObj);
                //this.removeLocalAdded();
                //this.saveSuccess(dataObj);

                //      dataObj = this.setFromReferenceData(dataObj);
                dataObj.calculateHours();
                this.gridData.push(dataObj);
                this.processGridData();
                this.saveSuccess(dataObj);
            }
            else {
                this.saveError(info.primaryReturn, info.message);
            }
        });
    }
    canEditRow(dataItem: DispatchLaborBus) {
        let canEdit = !dataItem.originalMgrApproved;
        return canEdit;
    }
    mgrApprove(dataItem: DispatchLaborBus) {
        dataItem.mgrApproved = true;
        dataItem.mgrApprovedDt = DateFunctions.getDateNow();
        dataItem.mgrApprovedUserId = this.globals.userId;
        this.save(dataItem);
        //let dataObj: DispatchLaborBus = new DispatchLaborBus(dataItem);
        //let dataObj2: DispatchLaborBus = this.getChangedObject(dataItem);

    }
    rowClassFunction(context: RowClassArgs) {
        let data: DispatchLaborBus = context.dataItem;
        if (data.needsNote == true) {
            return { needNote: true }
        }
        else {
            return { needNote: false }
        }
    }
}
